<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <SalabamLoginPage :service_title="service_title" :service_name="service_name"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import SalabamLoginPage from '@/components/salabam/SalabamLoginPage'

export default {
  name: 'SalabamShop',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Salabam Shop", link : 'conv-salabam-shop' } ],

        // Nome welfarebit del servizio
        service_title : "Salabam Shop",

        // Identificativo del servizio
        service_name : "salabam"
    }
  },
  components: {
    PageTagline,
    SalabamLoginPage
  }
}
</script>

<style scoped></style>